import { render, staticRenderFns } from "./reporte-general.vue?vue&type=template&id=00c860b3&scoped=true"
import script from "./reporte-general.vue?vue&type=script&lang=js"
export * from "./reporte-general.vue?vue&type=script&lang=js"
import style0 from "./reporte-general.vue?vue&type=style&index=0&id=00c860b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c860b3",
  null
  
)

export default component.exports